/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErroResponse,
  GravacaoConsultaResponse,
  GravacoesConsultaControllerEnviarTrechoBody,
  IniciarGravacaoDto,
  UrlDoTrechoResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGravacoesConsultaControllerIniciarUrl = () => {




  return `/v1/gravacoes-consulta`
}

/**
 * @summary Inicia a gravação de uma consulta. Exige `consentimentoTutor: true` — fica registrado quando e por quem o consentimento do tutor foi confirmado.
 */
export const gravacoesConsultaControllerIniciar = async (iniciarGravacaoDto: IniciarGravacaoDto, options?: Parameters<typeof httpClient>[1]): Promise<GravacaoConsultaResponse> => {

  return httpClient<GravacaoConsultaResponse>(getGravacoesConsultaControllerIniciarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(iniciarGravacaoDto)
  }
);}





export const getGravacoesConsultaControllerIniciarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerIniciar>>, TError,{data: IniciarGravacaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerIniciar>>, TError,{data: IniciarGravacaoDto}, TContext> => {

const mutationKey = ['gravacoesConsultaControllerIniciar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gravacoesConsultaControllerIniciar>>, {data: IniciarGravacaoDto}> = (props) => {
          const {data} = props ?? {};

          return  gravacoesConsultaControllerIniciar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GravacoesConsultaControllerIniciarMutationResult = NonNullable<Awaited<ReturnType<typeof gravacoesConsultaControllerIniciar>>>
    export type GravacoesConsultaControllerIniciarMutationBody = IniciarGravacaoDto
    export type GravacoesConsultaControllerIniciarMutationError = ErroResponse

    /**
 * @summary Inicia a gravação de uma consulta. Exige `consentimentoTutor: true` — fica registrado quando e por quem o consentimento do tutor foi confirmado.
 */
export const useGravacoesConsultaControllerIniciar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerIniciar>>, TError,{data: IniciarGravacaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gravacoesConsultaControllerIniciar>>,
        TError,
        {data: IniciarGravacaoDto},
        TContext
      > => {
      return useMutation(getGravacoesConsultaControllerIniciarMutationOptions(options), queryClient);
    }
    export const getGravacoesConsultaControllerEnviarTrechoUrl = (id: string,) => {




  return `/v1/gravacoes-consulta/${id}/trechos`
}

/**
 * @summary Envia um trecho da consulta (o navegador fecha um a cada ~5 min) e já o transcreve. Idempotente por `ordem`.
 */
export const gravacoesConsultaControllerEnviarTrecho = async (id: string,
    gravacoesConsultaControllerEnviarTrechoBody: GravacoesConsultaControllerEnviarTrechoBody, options?: Parameters<typeof httpClient>[1]): Promise<GravacaoConsultaResponse> => {
    const formData = new FormData();
formData.append(`audio`, gravacoesConsultaControllerEnviarTrechoBody.audio);
formData.append(`ordem`, gravacoesConsultaControllerEnviarTrechoBody.ordem.toString())
formData.append(`duracaoSegundos`, gravacoesConsultaControllerEnviarTrechoBody.duracaoSegundos.toString())

  return httpClient<GravacaoConsultaResponse>(getGravacoesConsultaControllerEnviarTrechoUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getGravacoesConsultaControllerEnviarTrechoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerEnviarTrecho>>, TError,{id: string;data: GravacoesConsultaControllerEnviarTrechoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerEnviarTrecho>>, TError,{id: string;data: GravacoesConsultaControllerEnviarTrechoBody}, TContext> => {

const mutationKey = ['gravacoesConsultaControllerEnviarTrecho'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gravacoesConsultaControllerEnviarTrecho>>, {id: string;data: GravacoesConsultaControllerEnviarTrechoBody}> = (props) => {
          const {id,data} = props ?? {};

          return  gravacoesConsultaControllerEnviarTrecho(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GravacoesConsultaControllerEnviarTrechoMutationResult = NonNullable<Awaited<ReturnType<typeof gravacoesConsultaControllerEnviarTrecho>>>
    export type GravacoesConsultaControllerEnviarTrechoMutationBody = GravacoesConsultaControllerEnviarTrechoBody
    export type GravacoesConsultaControllerEnviarTrechoMutationError = ErroResponse

    /**
 * @summary Envia um trecho da consulta (o navegador fecha um a cada ~5 min) e já o transcreve. Idempotente por `ordem`.
 */
export const useGravacoesConsultaControllerEnviarTrecho = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerEnviarTrecho>>, TError,{id: string;data: GravacoesConsultaControllerEnviarTrechoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gravacoesConsultaControllerEnviarTrecho>>,
        TError,
        {id: string;data: GravacoesConsultaControllerEnviarTrechoBody},
        TContext
      > => {
      return useMutation(getGravacoesConsultaControllerEnviarTrechoMutationOptions(options), queryClient);
    }
    export const getGravacoesConsultaControllerFinalizarUrl = (id: string,) => {




  return `/v1/gravacoes-consulta/${id}/finalizar`
}

/**
 * @summary Finaliza: monta a transcrição e gera o rascunho estruturado do prontuário. Pode ser chamado de novo para tentar outra vez quando a IA falhou (`resumo: null`).
 */
export const gravacoesConsultaControllerFinalizar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<GravacaoConsultaResponse> => {

  return httpClient<GravacaoConsultaResponse>(getGravacoesConsultaControllerFinalizarUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getGravacoesConsultaControllerFinalizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerFinalizar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerFinalizar>>, TError,{id: string}, TContext> => {

const mutationKey = ['gravacoesConsultaControllerFinalizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gravacoesConsultaControllerFinalizar>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  gravacoesConsultaControllerFinalizar(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GravacoesConsultaControllerFinalizarMutationResult = NonNullable<Awaited<ReturnType<typeof gravacoesConsultaControllerFinalizar>>>

    export type GravacoesConsultaControllerFinalizarMutationError = unknown

    /**
 * @summary Finaliza: monta a transcrição e gera o rascunho estruturado do prontuário. Pode ser chamado de novo para tentar outra vez quando a IA falhou (`resumo: null`).
 */
export const useGravacoesConsultaControllerFinalizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerFinalizar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gravacoesConsultaControllerFinalizar>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getGravacoesConsultaControllerFinalizarMutationOptions(options), queryClient);
    }
    export const getGravacoesConsultaControllerObterUrl = (id: string,) => {




  return `/v1/gravacoes-consulta/${id}`
}

/**
 * @summary Estado da gravação: trechos, transcrição e resumo
 */
export const gravacoesConsultaControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<GravacaoConsultaResponse> => {

  return httpClient<GravacaoConsultaResponse>(getGravacoesConsultaControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGravacoesConsultaControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/gravacoes-consulta/${id}`
    ] as const;
    }


export const getGravacoesConsultaControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGravacoesConsultaControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>> = ({ signal }) => gravacoesConsultaControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GravacoesConsultaControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>>
export type GravacoesConsultaControllerObterQueryError = ErroResponse


export function useGravacoesConsultaControllerObter<TData = Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>,
          TError,
          Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGravacoesConsultaControllerObter<TData = Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>,
          TError,
          Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGravacoesConsultaControllerObter<TData = Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Estado da gravação: trechos, transcrição e resumo
 */

export function useGravacoesConsultaControllerObter<TData = Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGravacoesConsultaControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGravacoesConsultaControllerDescartarUrl = (id: string,) => {




  return `/v1/gravacoes-consulta/${id}`
}

/**
 * @summary Descarta uma gravação que ainda não virou prontuário — apaga os áudios junto
 */
export const gravacoesConsultaControllerDescartar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getGravacoesConsultaControllerDescartarUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getGravacoesConsultaControllerDescartarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerDescartar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerDescartar>>, TError,{id: string}, TContext> => {

const mutationKey = ['gravacoesConsultaControllerDescartar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gravacoesConsultaControllerDescartar>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  gravacoesConsultaControllerDescartar(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GravacoesConsultaControllerDescartarMutationResult = NonNullable<Awaited<ReturnType<typeof gravacoesConsultaControllerDescartar>>>

    export type GravacoesConsultaControllerDescartarMutationError = ErroResponse

    /**
 * @summary Descarta uma gravação que ainda não virou prontuário — apaga os áudios junto
 */
export const useGravacoesConsultaControllerDescartar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerDescartar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gravacoesConsultaControllerDescartar>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getGravacoesConsultaControllerDescartarMutationOptions(options), queryClient);
    }
    export const getGravacoesConsultaControllerUrlDoTrechoUrl = (id: string,
    ordem: number,) => {




  return `/v1/gravacoes-consulta/${id}/trechos/${ordem}/arquivo`
}

/**
 * @summary URL assinada do áudio de um trecho
 */
export const gravacoesConsultaControllerUrlDoTrecho = async (id: string,
    ordem: number, options?: Parameters<typeof httpClient>[1]): Promise<UrlDoTrechoResponse> => {

  return httpClient<UrlDoTrechoResponse>(getGravacoesConsultaControllerUrlDoTrechoUrl(id,ordem),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGravacoesConsultaControllerUrlDoTrechoQueryKey = (id: string,
    ordem: number,) => {
    return [
    `/v1/gravacoes-consulta/${id}/trechos/${ordem}/arquivo`
    ] as const;
    }


export const getGravacoesConsultaControllerUrlDoTrechoQueryOptions = <TData = Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>, TError = ErroResponse>(id: string,
    ordem: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGravacoesConsultaControllerUrlDoTrechoQueryKey(id,ordem);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>> = ({ signal }) => gravacoesConsultaControllerUrlDoTrecho(id,ordem, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && ordem !== null && ordem !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GravacoesConsultaControllerUrlDoTrechoQueryResult = NonNullable<Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>>
export type GravacoesConsultaControllerUrlDoTrechoQueryError = ErroResponse


export function useGravacoesConsultaControllerUrlDoTrecho<TData = Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>, TError = ErroResponse>(
 id: string,
    ordem: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>,
          TError,
          Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGravacoesConsultaControllerUrlDoTrecho<TData = Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>, TError = ErroResponse>(
 id: string,
    ordem: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>,
          TError,
          Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGravacoesConsultaControllerUrlDoTrecho<TData = Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>, TError = ErroResponse>(
 id: string,
    ordem: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary URL assinada do áudio de um trecho
 */

export function useGravacoesConsultaControllerUrlDoTrecho<TData = Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>, TError = ErroResponse>(
 id: string,
    ordem: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gravacoesConsultaControllerUrlDoTrecho>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGravacoesConsultaControllerUrlDoTrechoQueryOptions(id,ordem,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






